<div class="heading heading_small">
  <img
    src="assets/icon-heart.svg"
    width="110"
    height="104"
    alt="Your favorites"
  />
  Dreambox
</div>

@if ({ images: images$ | async }; as asyncResult) {
  @if (asyncResult.images && asyncResult.images.length > 0) {
    <div class="gallery gallery_grid border-radius">
      @for (
        image of partialView
          ? asyncResult.images.slice(0, 8)
          : asyncResult.images;
        track image.id
      ) {
        <app-gallery-item
          [galleryItem]="image"
          [more]="
            partialView && $index === 7 && (totalCount$ | async)! > 8
              ? (totalCount$ | async)! - 7
              : undefined
          "
        />
      }

      @if (hasMoreResults$ | async) {
        <app-gallery-items-load-more (loadMore)="onLoadMore()" />
      }
    </div>
  } @else {
    <app-empty-block title="There are no objects in the Dreambox.">
      <p>
        Explore our image database and add your favorite images to the Dreambox
        so you can potentially purchase them later.
      </p>
    </app-empty-block>
  }
}
